/* eslint-disable no-alert, no-unreachable */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import authSelector from '../../../selectors/authSelector'
import {
  Well,
  ButtonToolbar,
} from '@sketchpixy/rubix'
import * as MabnaButton from '../Button/Button'
import { FETCH_CONTACTS_INFO } from '../../../actions/actions'

const phoneIcon = (
  <i className="fa fa-phone" style={{ fontSize: 18 }} aria-hidden="true" />
)

const telegramIcon = (
  <i className="fa fa-telegram" style={{ fontSize: 18 }} aria-hidden="true" />
)

const emailIcon = (
  <i className="fa fa-envelope" style={{ fontSize: 18 }} aria-hidden="true" />
)

const SupportInfoRow = ({ medium, icon, title }) => (
  <div className="support-row">
    <span className="support-row__icon">{icon}</span>

    <strong className="support-row__title">{title}</strong>
    <span>{medium && medium.value}</span>

    <span className="support-row__description">
      {medium && medium.description && medium.description}
    </span>
  </div>
)

const SupportInfo = ({ contacts: [phone, email, telegram] }) => {
  return (
    <section className="support-info-list">
      <SupportInfoRow medium={phone} title="شماره تلفن پشتیبانی: " icon={phoneIcon} />
      <SupportInfoRow medium={telegram} title="تلگرام: " icon={telegramIcon} />
      <SupportInfoRow medium={email} title="ایمیل: " icon={emailIcon} />
    </section>
  )
}

const ContactInfo = ({ contacts }) => (
  <section id="support-info-wrapper">
    <h3>اطلاعات تماس پشتیبانی</h3>

    <div style={{ marginLeft: 'auto' }}>
      <SupportInfo contacts={contacts} />
    </div>
  </section>
)

const Toolbar = ({showButton}) =>
  <Well>
    <ButtonToolbar>
      <span>
        <span>پشتیبانی</span>
      </span>

      {showButton &&
        <MabnaButton.Primary
          onClick={() => browserHistory.push('/dashboard/support/ticket/add')}
        >
          تیکت جدید
        </MabnaButton.Primary>
      }

    </ButtonToolbar>
  </Well>

const SupportNavigation = ({ userType }) => {
  return <h3>{userType}</h3>
}

class SupportContainer extends Component {
  componentWillMount() {
    this.props.dispatch({ type: FETCH_CONTACTS_INFO })
  }

  static contextTypes = { router: PropTypes.object }

  render() {
    const {
      userType,
      contacts,
      location: { pathname },
    } = this.props

    const isInComposeView = pathname !== '/dashboard/support/compose'
    const inAddOrReplyMode = pathname.includes('/support/ticket/')


    const navigationProps = {
      userType,
      isInComposeView,
      contacts,
    }

    return (
      <main className="support-container">
        <Toolbar showButton={!inAddOrReplyMode} />

        <section className="support-page">
          {this.props.children}
        </section>

        <ContactInfo {...navigationProps} />
      </main>
    )
  }
}

function mapStateToProps(state) {
  return {
    contacts: state.contacts,
    ...authSelector(state),
  }
}

export default connect(mapStateToProps)(SupportContainer)



// WEBPACK FOOTER //
// ./src/components/common/Support/Index.js